import { combineReducers } from 'redux'
import nav from './nav'

export default combineReducers({
	nav
})

// export default function (state = initialState, reducer) {
// 	return {
// 		actions: actions(state.actions, reducer),
// 		authentication: authentication(state.auth, reducer),
//			navigation: navigation(state.nav, reducer)
// 	}
// }



// WEBPACK FOOTER //
// ./src/reducers/index.js